import { MenuType } from 'src/components/common/MenuItemComponent';
import { hierarchyConfigs } from 'src/types/Translation';
import { IMenus } from './SearchHierarchy';

export const getSearchHierarchyInitialData = (hierarchyConfigs: hierarchyConfigs): IMenus => {
  return {
    sponsor: {
      label: hierarchyConfigs.sponsor,
      value: '',
      options: ['PiHealth'],
      resData: [],
      menuType: MenuType.Sponsor
    },
    study: {
      label: hierarchyConfigs.study,
      value: '',
      options: [],
      resData: [],
      menuType: MenuType.Study
    },
    country: {
      label: hierarchyConfigs.country,
      value: '',
      options: [],
      resData: [],
      menuType: MenuType.Country
    },
    site: {
      label: hierarchyConfigs.site,
      value: '',
      options: [],
      resData: [],
      menuType: MenuType.Site
    },
    tabHierarchyLevels: { Sponsor: false, Study: false, Country: false, Site: false }
  };
};
